/** Idade a partir de `LocalDate` (AAAA-MM-DD), sem `new Date` na data pura (ver CLAUDE.md). */
export const idadeEmAnos = (dataNascimento?: string, agora = new Date()) => {
  const [ano, mes, dia] = (dataNascimento ?? '').split('-').map(Number)
  if (!ano || !mes || !dia) return undefined
  const fezAniversario =
    agora.getMonth() + 1 > mes || (agora.getMonth() + 1 === mes && agora.getDate() >= dia)
  return agora.getFullYear() - ano - (fezAniversario ? 0 : 1)
}
